<template>
  <van-popup
    v-if="isMobile"
    v-model="show"
    position="right"
    :class="[
      isMobile ? 'right-mobile-popup' : 'right-pc-popup',
      withNoticeBar ? 'with-notice-bar' : '',
    ]"
    :style="{ height: isDesktop ? 'auto' : '100%' }"
    :get-container="parentContainer"
  >
    <slot name="header"></slot>
    <slot name="content"></slot>
  </van-popup>
  <van-popover
    v-else
    v-model="show"
    trigger="click"
    theme="dark"
    class="pc-popover"
    placement="bottom-end"
    get-container=".pc-popover"
  >
    <slot name="content"></slot>
  </van-popover>
</template>

<script>
  import { mapState } from 'vuex'
  import { getCurrentPage } from '@/utils/utils.js'

  export default {
    data() {
      return {
        show: false,
      }
    },
    props: {
      withNoticeBar: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(['isMobile', 'isDesktop']),
      currentPage() {
        return getCurrentPage(this.$route.path)
      },
      parentContainer() {
        return this.currentPage === 'home' && this.isDesktop
          ? '.home-page-container'
          : '.new-details-pc-content'
      },
    },
  }
</script>
